module.exports = __webpack_public_path__ + "img/UC_Banner_Powered.621889b1.png";